import classes from './Home.module.css';
import Category from './category/Category';
import Contacts from './contacts/Contacts';
import { useContext, useEffect, useRef, useState } from 'react';
import Suggestions from './suggestions/Suggestions';
import Bestsellers from './bestsellers/Bestsellers';
import { useDispatch, useSelector } from 'react-redux';
import LatestArticles from './latestArticles/LatestArticles';
import Carousel from '../../components/customCarousel/Carousel';
import Loader from '../../components/spinner/Loader';
import bestsellers from '../../store/bestsellers/Bestsellers';
import { firebaseAnalytics, logEvent } from '../../firebase/FirebaseConfig';
import { useLocation } from 'react-router-dom';
import { CategoriesContext } from '../../context/CategoriesContext';

const Home = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const bestsellersData = useSelector((state) => state.bestsellers.bestsellers);
  const [delay, setDelay] = useState(false)
  const bestsellersRef = useRef(null);
  const { categories } = useContext(CategoriesContext);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('scroll') === 'bestsellers' && bestsellersRef.current) {
      bestsellersRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location.search, delay]); 
  
  useEffect(() => {
    logEvent(firebaseAnalytics, 'Web_Home_page_visited')
    dispatch(bestsellers(4, 1));
  }, [dispatch]);

  if (categories?.length === 0 || !bestsellersData) {
    return <Loader />;
  }

  setTimeout(() => {
    setDelay(true)
  }, 200);

  return (
    <div className={`${classes.home_page_container} d-flex w-100 align-items-center justify-content-center flex-wrap`}>
      <Carousel />
      {delay &&
        <>
          <Category categories={categories} />
          <div ref={bestsellersRef}>
            <Bestsellers bestsellers={bestsellersData} categories={categories} />
          </div>
          <Contacts />
          <LatestArticles />
          <Suggestions />
        </>
      }
    </div>
  );
};

export default Home;
